import { useRef, useState, useEffect } from "react";
import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Flip, ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { styled } from '@mui/material/styles'; // MUI styling utility
import { FaEyeSlash } from "react-icons/fa"; // Password visibility icons
import { FaEye } from "react-icons/fa"; 
import { IoArrowBackSharp } from "react-icons/io5";

const LoginForm = () => {
    const [loading, setLoading] = useState(false); // Tracks if the loading spinner should show
    const history = useHistory(); // Allows navigation after successful login
    const subBtn = useRef(null); // Reference to submit button for keyboard handling
    const [attemptCount, setAttemptCount] = useState(0); // Tracks the number of failed attempts
    const [showError, setShowError] = useState(false); // Displays an error after multiple failed attempts
    const [showPassword, setShowPassword] = useState(false); // Toggles password visibility
    const [loginData, setLoginData] = useState({ // Holds form data (email and password)
        email: '',
        password: ''
    });

   /**
   * Handles input field changes and updates the state.
   * @param {Event} event - Input change event
   */
   const handleChange = (event) => {
    setLoginData({
      ...loginData,
      [event.target.name]: event.target.value
    });
  };
     /**
   * Handles login error responses and displays appropriate messages.
   * @param {Object} error - Axios error response
   */
  const handleLoginError = (error) => {
    if (error.response) {
      if (error.response.status === 400 && error.response.data.error.msg === "[ErrorDetail(string='You are not verified', code='invalid')]") {
        history.push("/Otpverify");
        return;
      }
  
      if (error.response.status === 404) {
        toast.error('Oops! Incorrect Credentials.', {
          position: "top-right",
          transition: Zoom,
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }
    }
  // Display a generic error message for other errors
    toast.error('Error during login. Please try again.', {
      position: "top-right",
      transition: Zoom,
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
   // Increment failed attempt count and show lockout message if threshold is reached
    setAttemptCount((prevCount) => prevCount + 1);
    if (attemptCount + 1 >= 3) {
      setShowError(true);
    }
  };
     
    const handleClick = async () => {
        if (loginData.email === '' || loginData.password === '') {
          toast.warn("Fields can't be empty!", { position: "top-right", transition: Flip, autoClose: 1500 });
          return;
        }
      
        try {
          const response = await toast.promise(
            axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/user/login/`, loginData, {
              headers: { Accept: 'application/json' }
            }),
            {
              pending: 'Getting you in..!',
              success: 'Login successful! Redirecting...'
            }
          );
      
          if (response.status === 200) {
            console.log("Login response:", response.data);
            const { access } = response.data.token;
            const role = response.data.token.role; 
            const usermail =response.data.token.usermail;
            sessionStorage.setItem("userToken", access);
            sessionStorage.setItem("userRole", role);
            sessionStorage.setItem("usermail",usermail);
            setAttemptCount(0);
            setShowError(false);
            setTimeout(() => pushToDashboard(role), 1500);
          }
        } catch (error) {
          handleLoginError(error);
        }
      };
   /**
   * Redirects user to the appropriate dashboard based on role.
   * @param {string} role - User role retrieved from API response
   */
   const pushToDashboard = (role) => {
    if (role === "Admin") {
      history.push('/power');
    } else if (role === "Customer") {
      history.push('/power');
    } else if (role === "Annoter") {
      history.push('/task');
    } else {
      history.push('/task'); 
    }
  };
    // Adds "Enter" key event listener for form submission
    useEffect(() => {
        function handleKeyDown(event) {
            if (event.keyCode === 13) {
                console.log("Enter");
                event.preventDefault();
                subBtn.current.click(); // Programmatically click the submit button
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    });

    // Clears session storage on component mount (for login state)
    useEffect(() => {
        sessionStorage.clear();
    }, []);

    // Material UI styling for some components (using styled API)
    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1),
        fontFamily: 'Montserrat'
    }));

    // Toggles password visibility (switching between text and password input types)
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    // JSX rendering the login form UI
    return (
        <div className="flex flex-col justify-center  items-center flex-1 h-screen px-6 py-12 lg:px-8 bg-gradient-to-b from-[#0e4749] via-[#155e63] to-[#0e4749]  relative ">
             <div className="absolute top-6 left-6 text-white text-3xl cursor-pointer hover:text-gray-300 transition duration-300">
    <Link to="/"><IoArrowBackSharp size={40} /></Link>
  </div>
            
            <div className=" bg-gradient-to-r from-white/20 pb-8  backdrop-blur-md  rounded-2xl w-[520px]  shadow-lg  transition-all duration-300 ease-in-out  ">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm ">
                <h2 className="mt-10 text-4xl font-bold leading-9 tracking-tight text-center text-white">Sign in</h2>
            </div>
            <hr className="mt-4 mx-9 border-gray-400 bg-gray-400" />
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm flex flex-col gap-2" style={{ zIndex: "10" }}>
                <div  className="gap-2">
                    <label htmlFor="email" className="block text-[16px] font-medium leading-6 text-white">
                        Email address
                    </label>
                    <div className="relative mt-2">
                        <input
                            id="email"
                            name="email"
                            type="email"
                            required
                            // className="block w-full h-14 focus:bg-gray-300/10 bg-gray-700/20 rounded-md border border-gray-100 p-2 text-white shadow-sm ring-1 ring-inset ring-gray-500/50 placeholder:text-gray-300 sm:text-xl sm:leading-6 outline-none"
                            className="block w-full h-[40px] bg-gray-700/20 rounded-md border border-gray-400 p-2 text-white shadow-sm  ring-gray-500/50 placeholder:text-gray-300 sm:text-xl sm:leading-6 outline-none focus:border-gray-300 focus:ring-gray-300"

                            onChange={(event) => handleChange(event)}
                        />
                        </div>
                </div>
                 <div>
                      <div className="flex items-center justify-between">
                          <label htmlFor="password" className="block text-[16px] font-medium leading-6 text-white">
                            Password
                          </label>
                    </div>
                    <div className="relative mt-2">
                        <input
                            id="password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            required
                            className="block w-full h-[40px] bg-gray-700/20 rounded-md border border-gray-400 p-2 text-white shadow-sm  ring-gray-500/50 placeholder:text-gray-300 sm:text-xl sm:leading-6 outline-none focus:border-gray-300 focus:ring-gray-300"
                            onChange={(event) => handleChange(event)}
                        />
                        <div
                            onClick={togglePasswordVisibility}
                            className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer text-gray-500 hover:text-gray-700"
                        >
                            {showPassword ? <FaEye color="white"  size={20}/> : <FaEyeSlash color="white" size={20} />} {/* Toggle between eye icon and eye-slash */}
                        </div>
                    </div>
                </div>
                <div>
                    <Link to="/task" className="font-medium text-xl text-white hover:text-orange-300 transition duration-300"></Link>
                    <button
                        type="submit"
                        className="mt-2 h-[40px] w-full rounded-md text-xl  transition delay-150 duration-300   bg-orange-400 text-white font-bold shadow-md hover:bg-white hover:text-orange-400 hover:border border-orange-400"
                        onClick={() => handleClick()}
                        ref={subBtn}
                         >
                        Submit
                    </button>
                    {showError && (
                        <div className="mt-4 text-white text-center text-lg font-semibold ">
                            Your account is locked due to multiple failed login attempts. Please reset your password!
                        </div>
                    )}
                </div>
                
            </div>
            </div>
           
            <ToastContainer /> {/* Toast notifications */}
        </div>
 
    );
};
export default LoginForm;
